import { resolve } from 'styled-jsx/css';
import { colors, fonts } from 'components/styles/variables';
import redCheckmark from 'public/static/images/red-checkmark.svg';

export const formCss = resolve`
  form {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

export const inputCss = resolve`
  input {
    border: 0;
    border-bottom: 1px solid ${colors.G1};
    border-radius: 0;
    color: ${colors.BLACK};
    font-size: 20px;
    width: 100%;
    font-family: ${fonts.default};
  }

  input:focus {
    outline: none;
  }
`;

export const errorCss = resolve`
  .error {
    color: ${colors.ALR1};
    font-size: 14px;
    text-align: right;
    height: 16px;
    width: 100%;
    font-weight: 700;
    margin-bottom: 6px;
  }
`;

export const checkboxCss = resolve`
  input {
    position: absolute;
    width: 28px;
    height: 28px;
    opacity: 0;
  }

  .checkmark {
    min-height: 28px;
    min-width: 28px;
    border-radius: 3px;
    border: 2px solid ${colors.G1};
  }

  input:hover ~ .checkmark {
    border: 2px solid ${colors.G2};
    background-color: ${colors.G1};
  }

  input:checked ~ .checkmark {
    border: 2px solid ${colors.ALR1};
    background-color: ${colors.ALR1};
    background-image: url(${redCheckmark});
    background-size: cover;
  }

  .accept-emails-container {
    display: flex;
    align-items: center;
    padding-top: 9px;
  }

  .accept-emails {
    font-size: 13px;
    font-weight: normal;
    text-transform: none;
    margin-left: 6px;
  }
`;

export const footerCss = resolve`
  .footer {
    border: none;
    color: ${colors.ALR1};
    font-size: 18px;
    outline: none;
    margin-top: 8px;
  }
`;
